export default __webpack_public_path__ + "static/media/masjid img.f68f6ecf.jpg";